import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import ShippingGallery from "../../Modals/shippingGallery";
import { APPROVAL_STATUS } from "../../utils/enums";

type props = {
  type: any;
  data: any;
};

const PersonalInformation = ({ type, data }: props) => {
  return (
    <>
      <div className="profileInfo_head">
        <h2>Personal Detail</h2>
        {/* <Button
          className="btn btn_secondary"
          onClick={() => navigate(`/edit-profile-detail/${type}/${data?._id}`)}
        >
          Edit Details
        </Button> */}
      </div>

      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          <li className="w_50">
            <strong>Name</strong>
            <span>{`${data?.firstName || "-"} ${data?.lastName || ""}`}</span>
          </li>
          <li className="w_50">
            <strong>E-mail</strong>
            <span>{data?.email || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Phone</strong>
            <span>{`${data?.countryCode || ""} ${data?.phone || "-"}`}</span>
          </li>

          <li className="w_50">
            <strong>Address</strong>
            <span>{"-"}</span>
          </li>

          <li className="w_50">
            <strong>Approval Status</strong>
            <span>Approved</span>
          </li>

          <li className="w_50">
            <strong>Number of Bookings</strong>
            <span>{"0"}</span>
          </li>

          <li className="w_50">
            <strong>Total Amount Spent collectively</strong>
            <span>{"0"}</span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default PersonalInformation;
